<template>
  <div id="themes-page" class="bg-gray-20 pb-6 md:pb-15">
    <mobile-sub-filter />
    <product-list-banners />
    <product-list />
  </div>
</template>

<script setup lang="ts">
import MobileSubFilter from '@/components/search/filter/mobile-sub-filter.vue'
import ProductListBanners from '@/components/product/product-list-banners.vue'
import ProductList from '@/components/product/product-list.vue'

await useCategoryPage()
</script>
